import {Component} from '@angular/core';

@Component({
    selector: 'app-view-event',
    templateUrl: './view-event.component.html',
    styleUrl: './view-event.component.css'
})
export class ViewEventComponent {

}
